import React, { Component } from "react";
// import { Line } from 'react-chartjs';
import { Line, Pie, Bar } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery";
import { Collapse } from "react-collapse";
import Loader from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import GetDomains from "../../../GetDomains";
import Select from 'react-select';

class DailyConvData extends Component {
  constructor() {
    super();
    this.state = {
      selectedDate: new Date(),
      totalNoOfData: 0,
      totalConversations: 0,
      totalChatDurationInMinutes: 0,
      totalTelephonyDurationInMinutes: 0,
      uniqueConversation: 0,
      averageChatDurationInSeconds: 0,
      averageTelephonyDurationInSeconds: 0,
      displayConvByHour: true,
      displayConvByLang: true,
      displayConvBySourceType: true,
      displayConvByDomain: true,
      showLoader: false,
      displayChatHandle: true,
      selectedDomainName: null,
      selectedDomainId: null,

      convByHourData: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "# of Conversations",
            borderColor: "#3BA4DC",
            pointColor: "#fff",
            responsive: true,
            pointStrokeColor: "#ccc",
            pointHoverRadius: 10,
            backgroundColor: ["rgba(60,167,224,0.4)"],
            fill: true,
          },
        ],
      },

      chatHandleData: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "# of Agents used",
            borderColor: "#3BA4DC",
            pointColor: "#fff",
            responsive: true,
            pointStrokeColor: "#ccc",
            pointHoverRadius: 10,
            backgroundColor: ["rgba(60,167,224,0.4)"],
            fill: true,
          },
        ],
      },

      convByLanguage: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },
      convBySourceType: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },

      convByDomain: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },
    };
    this.domains = [];
  }

  componentDidMount() {
    var selectedDate = this.state.selectedDate;
    this.fetchDomainsApi();
    this.fetchDailyCumulativeInfoApi(selectedDate);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      var selectedDate = thisController.state.selectedDate;
      thisController.projectId = event.projectId;
      thisController.domains = [];
      thisController.fetchDomainsApi();
      thisController.fetchDailyCumulativeInfoApi(selectedDate);
    });
  }

  notifyFailToLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }


  fetchDailyCumulativeInfoApi = (selectedDate) => {
    var DailyConvController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();
    $.ajax({
      url: "/api/daily-analytics/daily-cumulative-info",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        timeInMillis: longDate,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var convoInfo = res.result;
          DailyConvController.state.totalConversations =
            convoInfo.totalConversations;
          DailyConvController.state.totalChatDurationInMinutes =
            convoInfo.totalChatDurationInMinutes;
          DailyConvController.state.totalTelephonyDurationInMinutes =
            convoInfo.totalTelephonyDurationInMinutes;
          DailyConvController.state.totalChatDurationInSeconds =
            convoInfo.totalChatDurationInSeconds;
          DailyConvController.state.totalTelephonyDurationInSeconds =
            convoInfo.totalTelephonyDurationInSeconds;
          DailyConvController.state.uniqueConversation =
            convoInfo.uniqueConversation;
          DailyConvController.state.averageChatDurationInSeconds =
            convoInfo.averageChatDurationInSeconds;
          DailyConvController.state.averageTelephonyDurationInSeconds =
            convoInfo.averageTelephonyDurationInSeconds;
        }

        DailyConvController.setState(DailyConvController.state);
        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchConversationStatApi(selectedDate);

      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }

        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchConversationStatApi(selectedDate);
        DailyConvController.fetchLanguageStatApi(selectedDate);
        DailyConvController.fetchSourceTypeStatApi(selectedDate);
        DailyConvController.fetchDomainStatApi(selectedDate);
        DailyConvController.fetchChatHandleStatApi(selectedDate);
      },
    });
  };

  fetchConversationStatApi = (selectedDate) => {
    var DailyConvController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();
    $.ajax({
      url: "/api/daily-analytics/conversation-stat",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        date: longDate,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        DailyConvController.state.convByHourData["datasets"][0].data = [];
        DailyConvController.state.convByHourData["labels"] = [];
        if (res.success === true && res.result.length !== 0) {
          var dataSetDataAndLabel = DailyConvController.setDailyConvLabels(
            res.result
          );
          DailyConvController.state.convByHourData["datasets"][0].data =
            dataSetDataAndLabel.datasetData;
          DailyConvController.state.convByHourData["labels"] =
            dataSetDataAndLabel.labelData;

          var totalNoOfData = 0;
          for (var i = 0; i < res.result.length; i++) {
            var valueToInt = parseInt(res.result[i].value);
            totalNoOfData += valueToInt;
          }
          DailyConvController.state.totalNoOfData = totalNoOfData;
          DailyConvController.state.showLoader = true;
          DailyConvController.setState(DailyConvController.state);

          var selectedDate = DailyConvController.state.selectedDate;
          DailyConvController.fetchLanguageStatApi(selectedDate);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
        var selectedDate = DailyConvController.state.selectedDate;

        DailyConvController.fetchLanguageStatApi(selectedDate);
        DailyConvController.fetchSourceTypeStatApi(selectedDate);
        DailyConvController.fetchDomainStatApi(selectedDate);
        DailyConvController.fetchChatHandleStatApi(selectedDate);
      },
    });
  };

  fetchLanguageStatApi = (selectedDate) => {
    var DailyConvController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();
    $.ajax({
      url: "/api/daily-analytics/language-stat",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        date: longDate,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        DailyConvController.state.convByLanguage.labels = [];
        DailyConvController.state.convByLanguage.datasets[0].data = [];
        if (res.success === true && res.result.length !== 0) {
          for (var i = 0; i < res.result.length; i++) {
            DailyConvController.state.convByLanguage.labels.push(
              res.result[i].key
            );
            DailyConvController.state.convByLanguage.datasets[0].data.push(
              res.result[i].value
            );
          }
          DailyConvController.state.showLoader = true;
          DailyConvController.setState(DailyConvController.state);
        }

        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchSourceTypeStatApi(selectedDate);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }

        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchSourceTypeStatApi(selectedDate);
        DailyConvController.fetchDomainStatApi(selectedDate);
        DailyConvController.fetchChatHandleStatApi(selectedDate);
      },
    });
  };


  fetchSourceTypeStatApi = (selectedDate) => {
    var DailyConvController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();
    $.ajax({
      url: "/api/daily-analytics/source-type-stat",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        date: longDate,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        DailyConvController.state.convBySourceType.labels = [];
        DailyConvController.state.convBySourceType.datasets[0].data = [];
        if (res.success === true && res.result.length !== 0) {
          for (var i = 0; i < res.result.length; i++) {
            DailyConvController.state.convBySourceType.labels.push(
              res.result[i].key
            );
            DailyConvController.state.convBySourceType.datasets[0].data.push(
              res.result[i].value
            );
          }
          DailyConvController.state.showLoader = true;
          DailyConvController.setState(DailyConvController.state);
        }
        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchDomainStatApi(selectedDate);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchDomainStatApi(selectedDate);
        DailyConvController.fetchChatHandleStatApi(selectedDate);

      },
    });
  };

  fetchDomainStatApi = (selectedDate) => {
    if (!selectedDate) {
      selectedDate = this.state.selectedDate;
      if (!selectedDate) {
        selectedDate = new Date();
      }
    }

    var DailyConvController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();
    $.ajax({
      url: "/api/daily-analytics/domain-stat",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        date: longDate,
        domainId: DailyConvController.state.selectedDomainId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        DailyConvController.state.convByDomain.labels = [];
        DailyConvController.state.convByDomain.datasets[0].data = [];
        if (res.success === true && res.result.length !== 0) {
          for (var i = 0; i < res.result.length; i++) {
            DailyConvController.state.convByDomain.labels.push(
              res.result[i].key
            );
            DailyConvController.state.convByDomain.datasets[0].data.push(
              res.result[i].value
            );
          }
          DailyConvController.state.showLoader = true;
          DailyConvController.setState(DailyConvController.state);


        }
        var selectedDate = DailyConvController.state.selectedDate;
        DailyConvController.fetchChatHandleStatApi(selectedDate);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }

        var selectedDate = DailyConvController.state.selectedDate;
      },
    });
  };


  fetchChatHandleStatApi = (selectedDate) => {
    var DailyConvController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();
    $.ajax({
      url: "/api/daily-analytics/chat-handle-stat",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        date: longDate,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        DailyConvController.state.chatHandleData["datasets"][0].data = [];
        DailyConvController.state.chatHandleData["labels"] = [];
        var datasetData1 = [];
        var labelData = [];
        var datasetData2 = [];
        if (res.success === true && res.result.length !== 0) {
          for (var i = 0; i < res.result.length; i++) {
            datasetData1.push(res.result[i].noOfReservedChatHandles);
            labelData.push(res.result[i].time);
          }
          DailyConvController.state.chatHandleData["datasets"][0].data =
            datasetData1;
          DailyConvController.state.chatHandleData["labels"] = labelData;

          DailyConvController.state.showLoader = true;
          DailyConvController.setState(DailyConvController.state);
        }
      },
      error: function (xhr, status, error) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };
  setDailyConvLabels = (data) => {
    var DailyConvController = this;
    var labelData = [];
    var datasetData = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].key < "12") {
        if (data[i].key == "00") {
          labelData.push("12 AM - 1 AM");
        } else {
          if (data[i].key == "11") {
            labelData.push(
              Number(data[i].key) +
              " AM" +
              " - " +
              (Number(data[i].key) + 1) +
              " PM"
            );
          } else {
            labelData.push(
              Number(data[i].key) +
              " AM" +
              " - " +
              (Number(data[i].key) + 1) +
              " AM"
            );
          }
        }
      } else {
        if (data[i].key == "12") {
          labelData.push(
            Number(data[i].key) +
            " PM" +
            " - " +
            (Number(data[i].key) - 12 + 1) +
            " PM"
          );
        } else {
          if (data[i].key == "23") {
            labelData.push(
              Number(data[i].key) -
              12 +
              " PM" +
              " - " +
              (Number(data[i].key) - 12 + 1) +
              " AM"
            );
          } else {
            labelData.push(
              Number(data[i].key) -
              12 +
              " PM" +
              " - " +
              (Number(data[i].key) - 12 + 1) +
              " PM"
            );
          }
        }
      }
      datasetData.push(data[i].value);
    }
    return { datasetData: datasetData, labelData: labelData };
  };

  onDateChange = (date) => {
    this.state.selectedDate = date;
    this.fetchDailyCumulativeInfoApi(date);
  };

  refreshData = (id) => {
    var selectedDate = this.state.selectedDate;
    var refreshContent = this;
    refreshContent = this.state.editedId = id;
    this.fetchDailyCumulativeInfoApi(selectedDate);

  };

  isDateToday = (date) => {
    const currentDate = new Date();
    const isSameYear = date.getFullYear() === currentDate.getFullYear();
    const isSameMonth = date.getMonth() === currentDate.getMonth();
    const isSameDay = date.getDate() === currentDate.getDate();
    return isSameYear && isSameMonth && isSameDay;
  };

  formatTime = (timeInSeconds) => {
    let formattedTime = "";
    var selectedDate = this.state.selectedDate;
    if (this.isDateToday(selectedDate)) {
      formattedTime = "N/A";
    } else {
      formattedTime += Math.floor(timeInSeconds / 60) + " mins ";
      formattedTime += (timeInSeconds % 60) + " secs";
    }
    return formattedTime;
  };

  formatTotalConversations = (total) => {
    var selectedDate = this.state.selectedDate;
    if (this.isDateToday(selectedDate)) {
      return "N/A";
    }
    return total;
  };

  resetDate = () => {
    this.onDateChange(new Date());
  };

  displayConvByHour = () => {
    this.state.displayConvByHour
      ? this.setState({ displayConvByHour: false })
      : this.setState({ displayConvByHour: true });
  };

  displayConvByLang = () => {
    this.state.displayConvByLang
      ? this.setState({ displayConvByLang: false })
      : this.setState({ displayConvByLang: true });
  };

  displayConvBySourceType = () => {
    this.state.displayConvBySourceType
      ? this.setState({ displayConvBySourceType: false })
      : this.setState({ displayConvBySourceType: true });
  };

  displayConvByDomain = () => {
    this.state.displayConvByDomain
      ? this.setState({ displayConvByDomain: false })
      : this.setState({ displayConvByDomain: true });
  };

  displayChatHandle = () => {
    this.state.displayChatHandle
      ? this.setState({ displayChatHandle: false })
      : this.setState({ displayChatHandle: true });
  };

  handleDomainChange = (e) => {
    console.log("Changed to domain: " + e.label);
    this.state.selectedDomainName = e.label;
    this.state.selectedDomainId = e.value;
    localStorage.setItem("convDataDomainName", e.label);
    localStorage.setItem("convDataDomainId", e.value);
    this.setState(this.state);
    setTimeout(() => {
      this.fetchDomainStatApi();
    }, 500);
  }

  fetchDomainsApi = () => {
    var domainList = GetDomains();
    var isDomainIdInCurrentProject = false;
    for (var i = 0; i < domainList.length; i++) {
      if (localStorage.getItem("convDataDomainId") !== undefined &&
        domainList[i]["domainId"] === localStorage.getItem("convDataDomainId")) {
        isDomainIdInCurrentProject = true;
      }
      this.domains.push({ "value": domainList[i]["domainId"], "label": domainList[i]["domain"] });
    }

    if (this.props.location.state !== undefined) {
      if (isDomainIdInCurrentProject) {
        this.state.selectedDomainName = localStorage.getItem("convDataDomainName");
        this.state.selectedDomainId = localStorage.getItem("convDataDomainId");
      } else {
        this.state.selectedDomainName = this.domains[0].label;
        this.state.selectedDomainId = domainList[0]["domainId"];
      }
    } else {
      this.state.selectedDomainName = this.domains[0].label;
      this.state.selectedDomainId = domainList[0]["domainId"];
    }
  }

  render() {
    const selectedDomainOption = this.state.selectedDomainName;
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',  // Position the legend at the bottom
        labels: {
          boxWidth: 20,       // Size of the color box
          padding: 10         // Padding between text and color box
        }
      },
      layout: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    };
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={!this.state.showLoader}
          height={400}
          width={50}
          style={{ textAlign: "center" }}
        />
        {/* for toaster */}
        <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
        <div style={{ display: this.state.showLoader ? "block" : "none" }}>
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-7">
                <h6
                  className="nav-item"
                  style={{
                    color: "#282a65",
                    marginTop: "10px",
                    marginLeft: "7px",
                  }}
                >
                  Daily Conversation Data
                </h6>
              </div>

              <ToastContainer className="Toast-at-center" />

              <div className="col-sm-5 p-0">
                <div className="d-flex flex-row-reverse pt-2">
                  <button
                    className="btn action-button"
                    style={{ marginTop: "0px" }}
                    onClick={this.refreshData}
                    title="Refresh"
                  >
                    <img src="./assets/images/refresh_white_24dp.png" />
                  </button>

                  <button
                    className="btn action-button"
                    style={{ marginTop: "0px" }}
                    onClick={this.resetDate}
                  >
                    Reset
                  </button>

                  <DatePicker
                    id="date"
                    selected={this.state.selectedDate}
                    onChange={this.onDateChange}
                    dateFormat="dd/MM/yyyy"
                  ></DatePicker>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginLeft: "8px" }}>
            <h6>
              <img
                src={
                  this.state.displayConvByHour
                    ? "./assets/images/downward_arrow.png"
                    : "./assets/images/rightward_arrow.png"
                }
                onClick={this.displayConvByHour}
              />
              Conversations by Hour
              <br />
              <br />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "15rem",
                  color: "#150d50",
                  fontWeight: "500",
                }}
              >
                <p>
                  Total No Of Conversations :{" "}
                  {this.formatTotalConversations(this.state.totalConversations)}
                </p>
                <p>
                  Total Duration in Chat :{" "}
                  {this.formatTime(this.state.totalChatDurationInSeconds)}
                </p>
                <p>
                  Total Duration in Telephony :{" "}
                  {this.formatTime(this.state.totalTelephonyDurationInSeconds)}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "15rem",
                  color: "#150d50",
                  fontWeight: "500",
                }}
              >
                <p>
                  No Of Unique Conversations :{" "}
                  {this.formatTotalConversations(this.state.uniqueConversation)}
                </p>
                <p>
                  Average Duration in Chat :{" "}
                  {this.formatTime(this.state.averageChatDurationInSeconds)}
                </p>
                <p>
                  Average Duration in Telephony :{" "}
                  {this.formatTime(
                    this.state.averageTelephonyDurationInSeconds
                  )}
                </p>
              </div>
            </h6>
            <div className="col-lg-12">
              <Collapse isOpened={this.state.displayConvByHour}>
                <div className="card filled-line-chart">
                  <div className="card-body">
                    <div className="position-relative mb-4">
                      <Line
                        data={this.state.convByHourData}
                        width={1000}
                        height={200}
                      />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            <h6>
              <img
                src={
                  this.state.displayChatHandle
                    ? "./assets/images/downward_arrow.png"
                    : "./assets/images/rightward_arrow.png"
                }
                onClick={this.displayChatHandle}
              />
              Project Concurrencies
              <br />
              <br />
            </h6>
            <div className="col-lg-12">
              <Collapse isOpened={this.state.displayChatHandle}>
                <div className="card filled-line-chart">
                  <div className="card-body">
                    <div className="position-relative mb-4">
                      <Line
                        data={this.state.chatHandleData}
                        width={1000}
                        height={200}
                      />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="col-lg-6">
              <h6>
                <img
                  src={
                    this.state.displayConvByLang
                      ? "./assets/images/downward_arrow.png"
                      : "./assets/images/rightward_arrow.png"
                  }
                  onClick={this.displayConvByLang}
                />
                Conversations by Language
              </h6>
              <br />
              <Collapse isOpened={this.state.displayConvByLang}>
                <div className="card monthly-conversation-chart">
                  <div className="card-body">
                    <div className="chartHeight">
                      <Pie data={this.state.convByLanguage} />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="col-lg-6">
              <h6>
                <img
                  src={
                    this.state.displayConvBySourceType
                      ? "./assets/images/downward_arrow.png"
                      : "./assets/images/rightward_arrow.png"
                  }
                  onClick={this.displayConvBySourceType}
                />
                Conversations by Source type
              </h6>
              <br />
              <Collapse isOpened={this.state.displayConvBySourceType}>
                <div className="card monthly-conversation-chart">
                  <div className="card-body">
                    <div className="chartHeight">
                      <Pie data={this.state.convBySourceType} />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="col-lg-6">
              <h6>
                <img
                  src={
                    this.state.displayConvByDomain
                      ? "./assets/images/downward_arrow.png"
                      : "./assets/images/rightward_arrow.png"
                  }
                  onClick={this.displayConvByDomain}
                />
                Conversations by Domain
              </h6>
              <br />
              <Collapse isOpened={this.state.displayConvByDomain}>
                <div>
                  <div style={{ marginBottom: '15px' }}>
                    <Select
                      value={this.domains.filter(option => option.label === selectedDomainOption)}
                      onChange={this.handleDomainChange}
                      options={this.domains} />
                  </div>
                </div>
                <div className="card monthly-conversation-chart">
                  <div className="card-body">
                    <div className="chartHeight" style={{ height: '600px' }}>
                      <Pie data={this.state.convByDomain} options={options} />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DailyConvData;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/dailyReports/DailyConvData.js